// extracted by mini-css-extract-plugin
export default {"signIn":"QQ5bt","loginButtonInner":"gtAWY","links":"FSuu4"};